export const LOADING_COMPANIES = 'companies/LOADING_COMPANIES';
export const UPDATE_COMPANY_LIST = 'companies/UPDATE_COMPANY_LIST';
export const UPDATE_COMPANY = 'companies/UPDATE_COMPANY';
